/* eslint-disable react-hooks/exhaustive-deps */
import { alpha, Backdrop, Box, Button, CircularProgress, Divider, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import PostService from "../../../services/postService";
import { formatPrice, returnStringByLang } from "../../../utils";
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';


const ViewPostModal = ({
    open,
    handleClose,
    postId
}) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [post, setPost] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchPost = async () => {
        try {
            const data = await PostService.fetchOne(postId);
            setPost(data);
            setIsModalLoading(false);

        } catch (error) {
            console.error('Error fetching post:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchPost();
        }
    }, [open]);


    const changeStatusColor = (status) => {
        let returnStyle = {};
        switch (status) {
            case 'driver':
                returnStyle = {
                    fontWeight: 'bold',
                    color: theme.palette.purple.box
                };
                break;
            case 'inOffice':
                returnStyle = {
                    fontWeight: 'bold',
                    color: theme.palette.blue.bg
                };
                break;
            case 'returnToPage':
                returnStyle = {
                    fontWeight: 'bold',
                    color: theme.palette.yellow.border
                };
                break;
            default:
                returnStyle = {};
                break
        }
        return returnStyle;
    }


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '96%' : '70%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isTablet ? 2 : 4,
                        height: '80vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{
                        justifyContent: 'center', display: 'flex',
                        my: 10
                    }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('postInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    width: '100%'
                                }}>

                                {/* col 1 */}
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('user')}: <span style={{ fontWeight: 'bold' }}>{post.user?.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{post.branch.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('page')}: <span style={{ fontWeight: 'bold' }}>{post.page.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('driver')}: <span style={{ fontWeight: 'bold' }}>{post.driver?.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('city')}: <span style={{ fontWeight: 'bold' }}>{post.street?.city?.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('postType')}: <span style={{ fontWeight: 'bold' }}>{post.postType.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('totalPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(post.totalPrice)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('transportationPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(post.transportationPrice)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('driverPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(post.driverPrice)}</span>
                                    </Typography>

                                    <Box sx={{
                                        display: 'flex',
                                        mt: 2,
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant="body1" >
                                            {t('isPagePaid')}:
                                        </Typography>

                                        <Box width={'4px'}></Box>

                                        <Box
                                            sx={{
                                                bgcolor: alpha(
                                                    post.isPagePaid ? theme.palette.green.box : theme.palette.red.box, 0.2),
                                                width: 100,
                                                justifyContent: 'center',
                                                display: 'flex',
                                                py: 0.4,
                                                borderRadius: 0.6,
                                            }}
                                        >
                                            <Box sx={{
                                                fontWeight: 'bold',
                                                color: post.isPagePaid ? theme.palette.green.box : theme.palette.red.box,
                                            }}>
                                                {post.isPagePaid ? t('yes') : t('no')}</Box>
                                        </Box>
                                    </Box>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('createdAt')}: <span style={{ fontWeight: 'bold' }}>{t(post.createdAt)}</span>
                                    </Typography>

                                </Box>

                                {/* col 2 */}
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('invoiceNumber')}: <span style={{ fontWeight: 'bold' }}>{post.invoiceNumber}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('receiverName')}: <span style={{ fontWeight: 'bold' }}>{post.receiverName}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('receiverPhone')}: <span style={{ fontWeight: 'bold' }}>{post.receiverPhone}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('receiverPhoneTwo')}: <span style={{ fontWeight: 'bold' }}>{post.receiverPhoneTwo}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('street')}: <span style={{ fontWeight: 'bold' }}>{post.street?.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('receiverAddress')}: <span style={{ fontWeight: 'bold' }}>{post.receiverAddress}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('type')}: <span style={{ fontWeight: 'bold' }}>{t(post.type)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('changeStatus')}: <span style={changeStatusColor(post.changeStatus)}>{t(post.changeStatus)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('postStatus')}: <span style={{ fontWeight: 'bold', color: post.postStatus.color }}>
                                            {returnStringByLang(post.postStatus, i18n.language)}
                                        </span>
                                    </Typography>

                                    <Box sx={{
                                        display: 'flex',
                                        mt: 2,
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant="body1" >
                                            {t('isDriverPaid')}:
                                        </Typography>

                                        <Box width={'4px'}></Box>

                                        <Box
                                            sx={{
                                                bgcolor: alpha(
                                                    post.isDriverPaid ? theme.palette.green.box : theme.palette.red.box, 0.2),
                                                width: 100,
                                                justifyContent: 'center',
                                                display: 'flex',
                                                py: 0.4,
                                                borderRadius: 0.6,
                                            }}
                                        >
                                            <Box sx={{
                                                fontWeight: 'bold',
                                                color: post.isDriverPaid ? theme.palette.green.box : theme.palette.red.box,
                                            }}>
                                                {post.isDriverPaid ? t('yes') : t('no')}</Box>
                                        </Box>
                                    </Box>

                                    <Box sx={{
                                        display: 'flex',
                                        mt: 2,
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant="body1" >
                                            {t('isPriceUpdated')}:
                                        </Typography>

                                        <Box width={'4px'}></Box>

                                        <Box
                                            sx={{
                                                bgcolor: alpha(
                                                    !post.isPriceUpdated ? theme.palette.green.box : theme.palette.red.box, 0.2),
                                                width: 100,
                                                justifyContent: 'center',
                                                display: 'flex',
                                                py: 0.4,
                                                borderRadius: 0.6,
                                            }}
                                        >
                                            <Box sx={{
                                                fontWeight: 'bold',
                                                color: !post.isPriceUpdated ? theme.palette.green.box : theme.palette.red.box,
                                            }}>
                                                {post.isPriceUpdated ? t('yes') : t('no')}</Box>
                                        </Box>
                                    </Box>
                                </Box>

                            </Box>


                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('note')}: <span style={{ fontWeight: 'bold' }}>{post.note}</span>
                            </Typography>

                            {/* logs */}
                            <Divider sx={{ my: 2 }} />

                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {t('postLogs')}
                            </Typography>
                            {
                                post.postLogs.map((log, i) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: isMobile ? 'column' : 'row',
                                            bgcolor: alpha(theme.palette.primary.main, 0.2),
                                            borderRadius: 0.6,
                                            my: 2,
                                            height: isMobile ? 170 : 70,
                                            p: 1,
                                            width: '100%',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <Box width={isMobile ? '100%' : '20%'}>
                                            <Typography variant={isMobile ? "body2" : "body1"}>
                                                {t(log.userType)}: <span style={{ fontWeight: 'bold' }}>{t(log.name)}</span>
                                            </Typography>
                                        </Box>

                                        {log.logType === 'payment' ?
                                            <Box sx={{
                                                width: isMobile ? '100%' : '60%',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                                {
                                                    log.oldData.user === 'driver' ?
                                                        (log.oldData.action === 'add') ? <Typography variant={isMobile ? "body2" : "body1"}>
                                                            {t('driverPaymentAddedWithPrice')} <span style={{ fontWeight: 'bold' }}>{formatPrice(log.oldData.totalPrice)}</span>
                                                        </Typography> :
                                                            <Typography variant={isMobile ? "body2" : "body1"}>
                                                                {t('driverPaymentDeletedWithPrice')} <span style={{ fontWeight: 'bold' }}>{formatPrice(log.oldData.totalPrice)}</span>
                                                            </Typography>
                                                        :
                                                        (log.oldData.action === 'add') ? <Typography variant={isMobile ? "body2" : "body1"}>
                                                            {t('pagePaymentAddedWithPrice')} <span style={{ fontWeight: 'bold' }}>{formatPrice(log.oldData.totalPrice)}</span>
                                                        </Typography> :
                                                            <Typography variant={isMobile ? "body2" : "body1"}>
                                                                {t('pagePaymentDeletedWithPrice')} <span style={{ fontWeight: 'bold' }}>{formatPrice(log.oldData.totalPrice)}</span>
                                                            </Typography>
                                                }

                                            </Box>

                                            : <Box sx={{
                                                width: isMobile ? '100%' : '60%',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                                {
                                                    log.oldData.initial ?
                                                        <Typography variant={isMobile ? "body2" : "body1"}>
                                                            {t('createdPost')} <span style={{ fontWeight: 'bold' }}>{formatPrice(log.newData.totalPrice)}</span>
                                                        </Typography>
                                                        :
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: isMobile ? 'end' : 'center',
                                                                width: '100%'
                                                            }}>
                                                            {/* from */}
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: isMobile ? 'start' : 'center',
                                                                flexDirection: isMobile ? 'column' : 'row',
                                                                width: isMobile ? '100%' : '65%'
                                                            }}>
                                                                {
                                                                    isMobile ?
                                                                        <Typography variant={"body2"}>
                                                                            {t('changedPost')}
                                                                        </Typography>
                                                                        :
                                                                        <Typography variant={"body1"}>
                                                                            {t('changedPost')}&nbsp;&nbsp;&nbsp;
                                                                        </Typography>
                                                                }
                                                                <Box>
                                                                    <Typography variant={isMobile ? "body2" : "body1"}
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <SettingsOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {returnStringByLang(log.oldData.status, i18n.language)}
                                                                    </Typography>
                                                                    <Typography variant="subtitle2"
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                                                        <AttachMoneyOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {formatPrice(log.oldData.totalPrice)}
                                                                    </Typography>
                                                                    <Typography variant="subtitle2"
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                                                        <DriveEtaOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {log.oldData.driverName}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            {/* to */}
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: isMobile ? 'start' : 'center',
                                                                flexDirection: isMobile ? 'column' : 'row',
                                                                width: isMobile ? '100%' : '35%'
                                                            }}>
                                                                <Typography variant={isMobile ? "body2" : "body1"}>
                                                                    {t('to')}&nbsp;&nbsp;&nbsp;
                                                                </Typography>
                                                                <Box>
                                                                    <Typography variant={isMobile ? "body2" : "body1"}
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <SettingsOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {returnStringByLang(log.newData.status, i18n.language)}
                                                                    </Typography>
                                                                    <Typography variant="subtitle2"
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                                                        <AttachMoneyOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {formatPrice(log.newData.totalPrice)}
                                                                    </Typography>
                                                                    <Typography variant="subtitle2"
                                                                        style={{ fontWeight: 'bold', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                                                        <DriveEtaOutlinedIcon fontSize="small" />&nbsp;&nbsp;
                                                                        {log.newData.driverName}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Box>

                                                }

                                            </Box>}

                                        <Box width={isMobile ? '100%' : '20%'}>
                                            <Typography variant={isMobile ? "body2" : "body1"}>
                                                {t(log.createdAt)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))
                            }

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewPostModal;
